export const handleNavigation = (event, url, navigate) => {
    if (event.ctrlKey) {
        window.open(`${url}`, '_blank', 'noopener,noreferrer');
    } else {
        navigate(`/` + url);
    }
};
